export default __webpack_public_path__ + "static/media/png.407b1958.svg";